angular.module("warsApp.directives").directive("excelExport", [function () {
    return {
        restrict: "A",
        require: "ngModel",
        scope: {
            reportName: "@"
        },
        link: function (scope, element, attrs, ngModel) {
            $(element)
                .on("click",
                    function() {
                        var reportData = ngModel.$modelValue;
                        var rowIndex = 1;
                        var j, k, l, m, n, o, cell;
                        var ep = new ExcelPlus();
                        //create file
                        ep.createFile(scope.reportName);
                        //write column headers
                        var vals = [];
                        for (j = 0; j < reportData.columns.length; j++) {
                            var column = reportData.columns[j];
                            if (column.variableType === 31) continue;
                            vals.push(reportData.columns[j].name);
                        }
                        ep.writeRow(rowIndex, vals);
                        rowIndex += 1;
                        var shifts = [];
                        for (j = 0; j < reportData.columns.length; j++) {
                            shifts.push({
                                rowspan: 1,
                                aggregateInfo: ""
                            });
                        }
                        //write rows
                        for (j = 0; j < reportData.rows.length; j++) {
                            vals = [];
                            for (k = 0; k < reportData.rows[j].cells.length; k++) {
                                if (shifts[k].rowspan === 1) break;
                                if (shifts[k].aggregateInfo !== "") {
                                    vals.push(shifts[k].aggregateInfo);
                                    shifts[k].aggregateInfo = "";
                                } else {
                                    vals.push("");
                                }
                                shifts[k].rowspan -= 1;
                            }
                            for (k = 0; k < reportData.rows[j].cells.length; k++) {
                                cell = reportData.rows[j].cells[k];
                                if (vals.length === k) {
                                    if (shifts[k] != undefined) {
                                        shifts[k].rowspan = cell.rowspan;
                                        shifts[k].aggregateInfo = (cell.aggregateInfo !== null && cell.aggregateInfo !== undefined && cell.aggregateInfo !== "") ? cell.aggregateInfo : "";
                                    }
                                }
                                if (cell.isLink) continue;
                                if (cell.variableType === 6) {
                                    vals.push(cell.value ? "Yes" : "No");
                                } else if (cell.variableType === 3 || cell.variableType === 4 || cell.variableType === 5) {
                                    if (cell.value != undefined && cell.value != null && cell.value !== "") {
                                        vals.push(new Date(cell.value));
                                    } else {
                                        vals.push("");
                                    }
                                } else if (cell.value == null || cell.value == undefined) {
                                    vals.push("");
                                } else {
                                    vals.push(cell.value);
                                }
                            }
                            ep.writeRow(rowIndex, vals);
                            rowIndex += 1;
                            //child tables
                            for (l = 0; l < reportData.rows[j].tables.length; l++) {
                                var table = reportData.rows[j].tables[l];
                                if (table.name != undefined && table.name != null && table.name > "") {
                                    //table name
                                    vals = [];
                                    vals.push("");
                                    vals.push(table.name);
                                    ep.writeRow(rowIndex, vals);
                                    rowIndex += 1;
                                }
                                //table header
                                vals = [];
                                vals.push("");
                                for (m = 0; m < table.columnList.columns.length; m++) {
                                    vals.push(table.columnList.columns[m].name);
                                }
                                ep.writeRow(rowIndex, vals);
                                rowIndex += 1;
                                //table data
                                for (n = 0; n < table.rows.length; n++) {
                                    vals = [];
                                    vals.push("");
                                    for (o = 0; o < table.rows[n].cells.length; o++) {
                                        cell = table.rows[n].cells[o];
                                        if (vals.length === k) {
                                            if (shifts[k] != undefined) {
                                                shifts[k].rowspan = cell.rowspan;
                                                shifts[k].aggregateInfo = (cell.aggregateInfo !== null && cell.aggregateInfo !== undefined && cell.aggregateInfo !== "") ? cell.aggregateInfo : "";
                                            }
                                        }
                                        if (cell.isLink) continue;
                                        if (cell.variableType === 6) {
                                            vals.push(cell.value ? "Yes" : "No");
                                        } else if (cell.variableType === 3 || cell.variableType === 4 || cell.variableType === 5) {
                                            if (cell.value != undefined && cell.value != null && cell.value !== "") {
                                                vals.push(new Date(cell.value));
                                            } else {
                                                vals.push("");
                                            }
                                        } else if (cell.value == null || cell.value == undefined) {
                                            vals.push("");
                                        } else {
                                            vals.push(cell.value);
                                        }
                                    }
                                    ep.writeRow(rowIndex, vals);
                                    rowIndex += 1;
                                }
                            }
                        }
                        //save blob
                        ep.saveAs(scope.reportName + ".xlsx");
                    });
        }
    };
}]);